import MsDyn365, { IActionContext } from '@msdyn365-commerce/core';
import { getCartState } from '@msdyn365-commerce/global-state';
import { getProductVariantUrl } from '../getProductVariantUrl';
import { ProductsDataActions } from '@msdyn365-commerce/retail-proxy';

type SailthruCartItem = {
    id?: string;
    url: string;
    title: string;
    qty: number;
    price?: number;
    images?: {
        full?: { url: string };
        thumb?: { url: string };
    };
};

const handleCartChange = async (ctx: IActionContext) => {
    if (MsDyn365.isBrowser && window.Sailthru) {
        const sailthru = window.Sailthru;
        const userEmail = ctx.requestContext.user.emailAddress;

        // TODO: get user email from Sailthru

        process.env.NODE_ENV === 'development' && console.log('sailthru', 'handleCartChange', userEmail ?? 'no email');

        if (sailthru) {
            const baseImgUrl = ctx.requestContext.apiSettings.baseImageUrl;
            var channelId = ctx.requestContext.channel?.RecordId;
            const cart = await getCartState(ctx);

            const items: SailthruCartItem[] = [];
            for (const cartLine of cart.cart.CartLines ?? []) {
                let productDetails = await ProductsDataActions.getByIdAsync({ callerContext: ctx }, cartLine.ProductId!, channelId!);

                // It seems there's cache issue, retry if the return ID not matching
                if (cartLine.ProductId !== productDetails?.RecordId) {
                    productDetails = await ProductsDataActions.getByIdAsync({ callerContext: ctx }, cartLine.ProductId!, channelId!);
                }

                process.env.NODE_ENV === 'development' && console.log('sailthru', JSON.parse(JSON.stringify(productDetails)), cartLine);

                if (productDetails) {
                    const title = productDetails.Name ?? cartLine.Description;
                    const normalizedCanonicalUrl = getProductVariantUrl(productDetails, ctx);

                    items.push({
                        url: normalizedCanonicalUrl,
                        title: title ?? cartLine.ItemId ?? '',
                        id: productDetails.ProductNumber ?? cartLine.ItemId,
                        qty: cartLine.Quantity ?? 1,
                        images: {
                            full: {
                                url: `${baseImgUrl}Products%2F${encodeURIComponent(
                                    productDetails.ProductNumber ?? productDetails.ItemId ?? cartLine.ItemId ?? ''
                                )}_000_001.png&fallback=/Products/${encodeURIComponent(
                                    productDetails.ItemId ?? cartLine.ItemId ?? ''
                                )}_000_001.png&q=80&f=jpg`
                            }
                        },
                        price: cartLine.ExtendedPrice ? (cartLine.ExtendedPrice * 100) / (cartLine.Quantity ?? 1) : undefined
                    });
                }
            }

            process.env.NODE_ENV === 'development' && console.log('sailthru', 'items', items);

            sailthru.integration('purchase', {
                email: userEmail || undefined,
                incomplete: 1,
                items: items
            });
        }
    }
};

const cartActions = {
    handleCartChange
};

export { cartActions };
